<template>
    <div id="customer">
        <v-alert dense border="bottom" type="primary" icon="mdi-information">
            CUSTOMER INFORMATION
        </v-alert>
        <v-alert>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="4" sm="2" md="2">
                            <span class="font-weight-bold">Name :</span>
                        </v-col>
                        <v-col cols="8" sm="4" md="4">
                            <span>{{ detailcase.customer_name }}</span>
                        </v-col>
                        <v-col cols="4" sm="3" md="3">
                            <span class="font-weight-bold">Telephone :</span>
                        </v-col>
                        <v-col cols="8" sm="3" md="3">
                            <span>{{ detailcase.customer_tel }}</span>
                        </v-col>
                        <v-col cols="4" sm="2" md="2">
                            <span class="font-weight-bold">Email :</span>
                        </v-col>
                        <v-col cols="8" sm="10" md="10">
                            <span>{{ detailcase.customer_email }}</span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-alert>
    </div>
</template>
<script>
import axios from "axios"

export default {
    props: ["detailcase"],
    data() {
        return {}
    },
}
</script>
